import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { notification } from 'antd';
import { withRouter } from 'react-router';
import { pending } from 'redux-saga-thunk';
import get from 'lodash/get';
import CreativeSelect from '../../components/molecules/CreativeSelect';
import { resourceListReadRequest } from '../../store/resource/actions';
import { fromEntities, fromResource } from '../../store/selectors';
import { setEditRecord } from '../../store/updateCreative/actions';
import { modalShow } from '../../store/modal/actions';

class CreativeSelectContainer extends Component {
  componentDidMount() {
    this.props.getCreativeList().catch(e => {
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not retrieve creative list.',
        duration: 0,
      });
    });
  }

  render() {
    return (
      <CreativeSelect
        {...this.props}
        activeList={
          this.props.activeList
            ? this.props.activeList.map(a => parseInt(a.creative_service_id, 10))
            : []
        }
      />
    );
  }
}

const mapStateToProps = ({ modal, ...state }) => {
  return {
    creativeList: fromEntities
      .getList(state, 'adminCreative', fromResource.getList(state, 'adminCreative'))
      .map(a => ({ ...a, creative_service_id: parseInt(a.creative_service_id, 10) })),
    loading:
      pending(state, 'adminCreativeListRead') || pending(state, 'advertiserAdInhandCreativeCreate'),
  };
};
const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { campaignId },
    },
  }
) => ({
  showCreativeModal: creative => {
    if (get(creative, 'creative_service_id')) {
      dispatch(setEditRecord(creative));
    }

    dispatch(modalShow('create-creative'));
  },
  getCreativeList: () =>
    dispatch(
      resourceListReadRequest(
        `${process.env.REACT_APP_INMARKET_CREATIVE_API}/admin/creative`,
        { campaign_id: campaignId },
        {}
      )
    ),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CreativeSelectContainer);
